// this is generated file don't edit it manually!
import { IN3 } from '../../in3/sdk-wasm.js'
import { mapValues, toRPC, toBigInt } from '../util/convert'

/* A Node supporting IPFS must support these 2 RPC-Methods for uploading and downloading IPFS-Content. The node itself will run a ipfs-client to handle them.
 * 
 * Fetching ipfs-content can be easily verified by creating the ipfs-hash based on the received data and comparing it to the requested ipfs-hash. Since there is no chance of manipulating the data, there is also no need to put a deposit or convict a node. That's why the registry-contract allows a zero-deposit fot ipfs-nodes.
 * 
 */
export class Ipfs {
    in3: IN3

    /** initialiazes the Ipfs API
     * @param in3 - the incubed Client
     */
    constructor(in3: IN3) {
       this.in3 = in3
    }

    /** Fetches the data for a requested ipfs-hash. If the node is not able to resolve the hash or find the data a error should be reported.
    * @param ipfshash - the ipfs multi hash
    * @param encoding - the encoding used for the response. ( `hex` , `base64` or `utf8`)
    * @return the content matching the requested hash encoded in the defined encoding.
    * 
    * **Example**
    * 
    * ```js
    * let result = await sdk.ipfs.get("QmSepGsypERjq71BSm4Cjq7j8tyAUnCw6ZDTeNdE8RUssD", "utf8")
    * //  result = I love Incubed
    * ```
    * 
    */
    get(ipfshash: string, encoding: string) : Promise<string> {
        return this.in3.sendRPC("ipfs_get",[ ipfshash, encoding ])
    }

    /** Stores ipfs-content to the ipfs network.
     * Important! As a client there is no garuantee that a node made this content available. ( just like `eth_sendRawTransaction` will only broadcast it). 
     * Even if the node stores the content there is no gurantee it will do it forever. 
     * 
    * @param data - the content encoded with the specified encoding.
    * @param encoding - the encoding used for the request. ( `hex` , `base64` or `utf8`)
    * @return the ipfs multi hash
    * 
    * **Example**
    * 
    * ```js
    * let result = await sdk.ipfs.put("I love Incubed", "utf8")
    * //  result = QmSepGsypERjq71BSm4Cjq7j8tyAUnCw6ZDTeNdE8RUssD
    * ```
    * 
    */
    put(data: string, encoding: string) : Promise<string> {
        return this.in3.sendRPC("ipfs_put",[ data, encoding ])
    }


}


export default Ipfs
